export default __webpack_public_path__ + "static/media/consulting-6.54755cfa.jpg";